import React from 'react'
import {getSizedImageUrl} from '@shopify/theme-images';
import PriceDisplay from '../../PriceDisplay'
import LoadingIcon from './Loading'

import {LineItem} from '../../../util/typings'
import useCartLineItem from '../../../hooks/useCartLineItem'
import getRoute from '../../../../scripts/utils/getRoute';
import formatSizeNames from '../../../../scripts/utils/formatSizeNames'


type Props = {
  lineItem: LineItem,
  langStrings: Record<string, string>
}

const CartLineItem: React.FunctionComponent<Props> = ({ lineItem, langStrings }: Props) => {
  const { removeText, freeGiftMessage } = langStrings;
  const { increment, changeQuantity, decrement, remove, removing, itemUpdating, displayQuantity } = useCartLineItem(lineItem)

  const productUrl: string | null = lineItem.handle ? `${getRoute()}products/${ lineItem.handle }` : null;
  const imageUrl: string | null = lineItem.featured_image && lineItem.featured_image.url ? getSizedImageUrl(lineItem.featured_image.url, '224x336') : null;

  return (
    <li className={`minicart-item ${removing ? 'removing' : ''}`}>
      <div className="minicart-item-image-wrap">
        { imageUrl ? (
          productUrl ? (
            <a href={productUrl}>
              <img alt={lineItem.product_title || ''} loading="lazy" width="112" height="168" src={imageUrl} />
            </a>
          ) : (
            <img alt={lineItem.product_title || ''} loading="lazy" width="112" height="168" src={imageUrl} />
          )
        ) : null }
      </div>
      <div className="minicart-item-details">
        <h5 className="minicart-item-title">
          { productUrl ? (
            <a href={productUrl}> {lineItem.product_title}{lineItem.variant_title ? ` - ${formatSizeNames(lineItem.variant_title, null, null, true)}` : ''}</a>
          ) : (
            <span>{lineItem.product_title}{lineItem.variant_title ? ` - ${formatSizeNames(lineItem.variant_title, null, null, true)}` : ''}</span>
          ) }
        </h5>
        { lineItem.price !== 0 && !(lineItem.properties && Object.keys(lineItem.properties).includes('_free_gift')) ? (
          <>
            <PriceDisplay cart={true} product={lineItem} />
            <div className="minicart-items-quantity">
              <button  disabled={parseInt(displayQuantity.toString()) < 2 || itemUpdating} onClick={decrement}>-</button>
              <span className="minicart-item-quantity-number">
                { itemUpdating ? (<LoadingIcon />) : ''}
                <input
                  type="number"
                  disabled={itemUpdating}
                  value={displayQuantity}
                  onBlur={(e) => !e.target.value ? changeQuantity(lineItem.quantity) : null} //if blank when blured switch back to actual value
                  onChange={e => changeQuantity(e.target.value)}
                ></input>
              </span>
              <button disabled={itemUpdating} onClick={increment}>+</button>
            </div>
            <button className="minicart-item-remove" onClick={remove}>{ removeText }</button>
          </>
        ) : (lineItem.properties && Object.keys(lineItem.properties).includes('_free_gift')) ?
          (<p>{ freeGiftMessage }</p>)
          : null }

      </div>
    </li>

  )
}

export default CartLineItem
